export type CustomerType = 'PAC' | 'PBI' | 'PBI+';

export interface IUser {
    id: number;
    username: string;
    name: string | null;
    cardcode: string | null;
    slpcode: number | null;
    email: string | null;
    status: 1 | 0;
    permissionId: number | null;
    customer?: IUserCustomer;
    typeId: EUserType;
    createdAt: number;
    updatedAt: number | null;
}

export interface IUserCreationInfo {
    email: string;
    name: string | null;
    password: string;
    typeId: number;
}

export enum EUserType {
    None = 0,
    Admin = 1,
    Portal = 2,
    Internal = 3
}

export enum EUserTypeName {
    None = 'None',
    Admin = 'Admin',
    Portal = 'Portal',
    Internal = 'Internal'
}

export interface ICustomerAddress {
    addressId: number;
    cardcode: string;
    address: string;
    addressType: 'B' | 'S';
    isDefault: 0 | 1;
    country: string | null;
    city: string | null;
    street: string;
    state: string | null;
    block: string | null;
    zipcode: string | null;
}

export interface IUserCustomer {
    address: {
        billing: ICustomerAddress[];
        shipping: ICustomerAddress[];
    };
    balance: string;
    cardcode: string;
    cardname: string;
    contactname: string;
    custgroup: 'PBI' | 'PBI+' | 'PAC' | null;
    email: string | null;
    groupcode: number;
    groupnum: number;
    listnum: number;
    message: string | null;
    slpcode: number;
    slpname: string;
    splgroup: number | null;
    terms: string;
    whsName: string;
    whscode: string;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/user.ts